import React from 'react';
import { Flex, Text } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { GridLoader } from 'react-spinners';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Loading(props) {
  const {
    message = 'Loading...',
    titleVariant = 'loadingMessage|dialogTitle'
  } = props;
  const Loader = Config.get('LoadingScreen', 'spinner', GridLoader);
  const loaderProps = Config.get('LoadingScreen', 'props', {});
  const {
    size = loaderProps.size || 30,
    color
  } = props;
  return /*#__PURE__*/_jsxs(Flex, {
    direction: "column",
    justify: "center",
    align: "center",
    style: {
      height: 500,
      gap: 30
    },
    children: [/*#__PURE__*/_jsx(Text, {
      variant: titleVariant,
      children: message
    }), /*#__PURE__*/_jsx(Loader, {
      size: size,
      color: color || 'var( --color-loader, var( --color-brand200, #dedede ) )'
    })]
  });
}